import { GetTokenError, NotLoggedInError } from './errors';
import type { AuthToken } from './storage';

/**
 * Check a response from the `/token` endpoint.
 *
 * Returns a new token to store if we have one.
 * If 204, our existing token is valid, so we return it.
 * Otherwise, reject with an error.
 */
export const checkTokenResponse = async (
  response: Response,
  existingToken: AuthToken | undefined
): Promise<AuthToken> => {
  if (response.ok && response.status === 204) {
    if (!existingToken) {
      throw new NotLoggedInError();
    }

    return existingToken;
  }

  if (response.ok) {
    try {
      return (await response.json()) as AuthToken;
    } catch {
      throw new GetTokenError();
    }
  }

  if (response.status === 400 || response.status === 401) {
    throw new NotLoggedInError();
  }

  throw new GetTokenError();
};
